/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */

import React from "react";
import { Card } from "antd";
import "./stylescroll.css";
import { ForwardOutlined } from "@ant-design/icons";
import "./HomePageStyles.css";
import NoImage from "../../assets/no-image.jpg";
const Cradlist4 = ({ data }) => {
  const dataArray = Object.values(data || {});
  return (
    <Card
      // style={{ maxHeight: "40vh", borderRadius: "15px" }}
      title={
        <div className="moving-gradient-header">
          <span>NEWS & ANNOUNCEMENTS</span>
        </div>
      }
      size="small"
      headStyle={{
        padding: 0,
        borderBottom: "none",
      }}
      bodyStyle={{
        padding: 16,
      }}
      style={{ borderRadius: 16, overflow: "hidden", maxHeight: "47vh" }}
    >
      <div
        className="scroll-container"
        style={{
          maxHeight: "42vh",

          //   overflowY: "auto", // Use scroll instead of auto
        }}
      >
        {dataArray?.map((item, index) => (
          <Card
            key={item.id}
            title={
              <div className="card-title-wrapper">
                <p className="card-title-text">{item.title}</p>
                <div className="custom-extra">
                  <a href={item.link} target="_blank" rel="noreferrer">
                    Know more
                  </a>
                  <ForwardOutlined className="see-more-icon" />
                </div>
              </div>
            }
            className={`custom-card ${
              index % 2 === 0 ? "card-light-blue" : "card-light-gray"
            }`}
            hoverable
            size="small"
          >
            <div className="card-body">
              <div className="card-image-wrapper">
                <img
                  src={item.featured_image || NoImage}
                  alt={""}
                  className="card-image"
                />
              </div>
              <div className="card-content">
                <p className="card-description">{item.description}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </Card>
  );
};

export default Cradlist4;
